export default __webpack_public_path__ + "static/media/commercial-demo-extended.58b9dfde.mp3";